import React, { useCallback, useEffect, useState } from "react";
import { PageTitle } from "../../../../Components";
import { ContactsInformationComponent } from "../../ContactsView";
import { PermissionDeniedLayout } from "../../../../Layouts/PermissionDeniedLayout/PermissionDeniedLayout";
import { GetAdvanceSearchContacts, GetSensitiveFieldsForUser } from "../../../../Services";
import { useQuery } from "../../../../Hooks";

// Styles
import useStyles from "./styles";

function NewEditContactView() {
  const styles = useStyles();

  const query = useQuery();
  const contactId = +query.get("id");

  const [displayDetailsToUserDependsOnPolicy, setDisplayDetailsToUserDependsOnPolicy] = useState(null);
  const [contactEmptyFields, setContactEmptyFields] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [contactWithPolicy, setContactWithPolicy] = useState(null);
  const [activeContactData, setActiveContactData] = useState();
  const [isLoadingSensitiveField, setIsLoadingSensitiveField] = useState(false);
  const [sensitiveFieldsForUser, setSensitiveFieldsForUser] = useState([]);
  const [isSensitiveLoading, setIsSensitiveLoading] = useState(0);

  const userHasPolicyToDisplayData = useCallback(async (contactId) => {
    setIsLoading(true);
    const isForLog = true;

    let body = {
      criteria: {
        Ids: [{ searchType: 1, value: contactId }],
      },
      filterBy: "createdOn",
      orderBy: 2,
    };
    const res = await GetAdvanceSearchContacts(
      { pageIndex: 0, pageSize: 2, isForLog },
      body
    );
    if (!(res && res.status && res.status !== 200)) {
      if (res && res.totalCount > 0) {
        if (
          res &&
          res.result &&
          res.result.length &&
          res.result[0].contactJson
        ) {
          const contactData = res.result[0];
          setContactEmptyFields(
            JSON.parse(
              res && res.result && res.result[0] && res.result[0].contactJson
            )
          );
          
          const contactJson = JSON.parse(contactData.contactJson);

          const activeContact = {
            contact: {
              id: contactData.contactId,
              ...contactJson.contact,
            },
          };
          setContactWithPolicy(contactJson);
          setActiveContactData(activeContact);
          setDisplayDetailsToUserDependsOnPolicy("allowed");
        }
      } else {
        setDisplayDetailsToUserDependsOnPolicy("notAllowed");
        setContactWithPolicy(null);
        setActiveContactData(null);
      }
    } else {
      setContactWithPolicy(null);
      setActiveContactData(null);
      setDisplayDetailsToUserDependsOnPolicy("notAllowed");
    }
    setIsLoading(false);
  });

  const GetSensitiveFieldsForUserAPI = useCallback(
    async (sensitiveContactId) => {
      setIsLoadingSensitiveField(true);
      const allSensitiveFields = await GetSensitiveFieldsForUser(
        contactWithPolicy &&
          contactWithPolicy.contact &&
          contactWithPolicy.contact.contact_type_id,
        contactWithPolicy && { key: "contact", id: sensitiveContactId }
      );
      
      if (
        !(
          allSensitiveFields &&
          allSensitiveFields.status &&
          allSensitiveFields.status !== 200
        )
      ) {
        setSensitiveFieldsForUser(allSensitiveFields);
        setIsSensitiveLoading(1);
      } else {
        setSensitiveFieldsForUser([]);
        setIsSensitiveLoading(2);
      }
      setIsLoadingSensitiveField(false);
    },
    [contactWithPolicy]
  );

  const reloadData = () => {
    userHasPolicyToDisplayData(contactId);
    GetSensitiveFieldsForUserAPI(
      activeContactData &&
        activeContactData.contact &&
        activeContactData.contact.id
    );
  };

  useEffect(() => {
    userHasPolicyToDisplayData(contactId);

    GetSensitiveFieldsForUserAPI(
      activeContactData &&
        activeContactData.contact &&
        activeContactData.contact.id
    );
  }, []);

  return (
    <>
      <PageTitle
        title={"Edit contact overview"}
        subTitle={"Update and refine contact details and overview information to maintain accurate and current profiles."}
        hideDivider
        showBackIcon
        wrapperClasses={styles.pageTitleWrapper}
      />

      {displayDetailsToUserDependsOnPolicy === "allowed" && (
        <ContactsInformationComponent 
          viewType={1}
          parentTranslationPath={"ContactProfileManagementView"}                          
          translationPath={""}
          contactWithPolicy={contactWithPolicy}
          sensitiveFieldsForUser={sensitiveFieldsForUser}
          isSensitiveLoading={isSensitiveLoading}
          isLoading={isLoading}
          reloadData={reloadData}
          contactEmptyFields={{ ...contactEmptyFields }}
        />
      )}

      {displayDetailsToUserDependsOnPolicy === "notAllowed" && (
        <PermissionDeniedLayout />
      )}
    </>
  );
}

export default NewEditContactView;
